import sizeWarning from './sizeWarning.html';
import webGlWarning from './webGlWarning.html';
import './warning.scss';

let webGlSupported = mapboxgl.supported(),
    w = window.innerWidth,
    h = window.innerHeight,
    warningsContainer = document.createElement('div'),
    warningsHtml = '';

warningsContainer.id = 'warnings-container';

// check screen size
if (w < 950 || h < 650) {
    warningsHtml += sizeWarning;
}

// check mapboxgl support
if (!webGlSupported) {
    warningsHtml += webGlWarning;
}

if (warningsHtml) {
    // add alert elements
    warningsContainer.innerHTML = warningsHtml;
    document.querySelector('body').appendChild(warningsContainer);

    // close buttons
    let closeButtons = document.querySelectorAll('.alert .close');
    for (let i = 0, n = closeButtons.length; i < n; i++) {
        closeButtons[i].addEventListener('click', function(){
            warningsContainer.removeChild(this.parentNode);
        });
    }
}



// WEBPACK FOOTER //
// ./src/js/supportWarning/warning.js